
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [uiMixin],
  props: {
    step: {
      required: true,
      type: Object,
      default: () => {},
    },
    options: {
      required: false,
      type: Object,
      default: () => ({}),
    },
    isLoaded: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  computed: {
    mergedOptions() {
      return {
        ...this.options,
      };
    },
  },
};
